var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavClose = function SvgNavClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92 8.608h9.6a.16.16 0 0 0 .16-.16V7.336a.16.16 0 0 0-.16-.159h-9.6a.16.16 0 0 0-.16.16v1.113c0 .087.072.159.16.159Zm-.16 4.057c0 .087.072.159.16.159h9.6a.16.16 0 0 0 .16-.16v-1.113a.16.16 0 0 0-.16-.159h-9.6a.16.16 0 0 0-.16.16v1.113ZM17.84 3H2.16a.16.16 0 0 0-.16.16v1.113c0 .087.072.159.16.159h15.68a.16.16 0 0 0 .16-.16V3.16A.16.16 0 0 0 17.84 3Zm0 12.568H2.16a.16.16 0 0 0-.16.16v1.113c0 .087.072.159.16.159h15.68a.16.16 0 0 0 .16-.16v-1.113a.16.16 0 0 0-.16-.159Zm-15.772-5.43 3.126 2.447c.116.092.288.01.288-.137V7.552a.177.177 0 0 0-.288-.137L2.068 9.863a.174.174 0 0 0 0 .274Z",
    fill: "#666"
  })));
};
export default SvgNavClose;